/**
 *
 * ListViewAllCard
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowIcon from 'components/DiscoverLink/right-arrow.svg';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Mixpanel from 'utils/mixpanelService';

const useStyles = makeStyles({
  container: {
    boxShadow: 'none !important',
    borderRadius: '5px !important',
    border: `1px solid #E9ECED`,
    height: 271,
    width: 'auto',
    position: 'relative',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: 32,
    height: 32,
  },
});

function ListViewAllCard({ url, onBeforeClick }) {
  const classes = useStyles();
  const [siteCopy] = useSiteCopySelector(['resources']);

  const onClick = () => {
    onBeforeClick();
    Mixpanel.track('List - Carousel View All - Clicked', {
      list: url,
    });
  };

  return (
    <Link to={url} onClick={onClick}>
      <div className={classes.container}>
        <Typography variant="h5" color="primary" gutterBottom>
          {_get(siteCopy, 'pageCopy.viewAllLabel')}
        </Typography>
        <img src={ArrowIcon} className={classes.icon} alt="" />
      </div>
    </Link>
  );
}

ListViewAllCard.propTypes = {
  url: PropTypes.string,
  onBeforeClick: PropTypes.func,
};

ListViewAllCard.defaultProps = {
  onBeforeClick: () => {},
};

export default ListViewAllCard;
